/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './booking-rate-calulation.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/forms';
import * as import3 from '@angular/common';
import * as import4 from '../../../../app/booking-management/booking-rate-calculation /booking-rate-calulation.component';
const styles_BookingRateCalulationComponent:any[] = [import0.styles];
export const RenderType_BookingRateCalulationComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_BookingRateCalulationComponent,
  data: {}
}
);
function View_BookingRateCalulationComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'inline-icon error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oops! Only numerical values and "." are allowed.'])),
    (l()(),import1.ɵted((null as any),['!\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_BookingRateCalulationComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'inline-icon error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oops! Only numerical values and \'.\' are allowed.'])),
    (l()(),import1.ɵted((null as any),['!\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_BookingRateCalulationComponent_3(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'inline-icon error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oops! Only numerical values and "." are allowed.'])),
    (l()(),import1.ɵted((null as any),['!\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_BookingRateCalulationComponent_4(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'inline-icon error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oops! Only numerical values and \'.\' are allowed.'])),
    (l()(),import1.ɵted((null as any),['!\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_BookingRateCalulationComponent_6(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'inline-icon error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oops! Only numerical values and \'.\' are allowed.'])),
    (l()(),import1.ɵted((null as any),['!\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_BookingRateCalulationComponent_5(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'payroll-card__measure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll-card__measure-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Inter. rate NG'])),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'input',[
      [
        'class',
        'payroll-card__measure-input'
      ]
      ,
      [
        'pattern',
        '\\$?(\\d+|\\d+(\\.)\\d+)'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,8)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,8).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,8)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,8)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.payrollInvoice.interpreting_night_rate = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(540672,(null as any),0,import2.PatternValidator,([] as any[]),{pattern: [
        0,
        'pattern'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.PatternValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
      import1.ɵdid(671744,[[
        'interRateNG',
        4
      ]
    ],0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingRateCalulationComponent_6)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_10:any = '\\$?(\\d+|\\d+(\\.)\\d+)';
    ck(v,9,0,currVal_10);
    const currVal_11:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'interRateNG_') + co.index),'');
    const currVal_12:any = ((co.payrollInvoice == null)? (null as any): co.payrollInvoice.interpreting_night_rate);
    ck(v,12,0,currVal_11,currVal_12);
    const currVal_13:any = (import1.ɵnov(v,12).touched && ((import1.ɵnov(v,12).errors == null)? (null as any): import1.ɵnov(v,12).errors.pattern));
    ck(v,17,0,currVal_13);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.isReadOnly;
    const currVal_1:any = co.totalPlaceholder;
    const currVal_2:any = (import1.ɵnov(v,9).pattern? import1.ɵnov(v,9).pattern: (null as any));
    const currVal_3:any = import1.ɵnov(v,14).ngClassUntouched;
    const currVal_4:any = import1.ɵnov(v,14).ngClassTouched;
    const currVal_5:any = import1.ɵnov(v,14).ngClassPristine;
    const currVal_6:any = import1.ɵnov(v,14).ngClassDirty;
    const currVal_7:any = import1.ɵnov(v,14).ngClassValid;
    const currVal_8:any = import1.ɵnov(v,14).ngClassInvalid;
    const currVal_9:any = import1.ɵnov(v,14).ngClassPending;
    ck(v,7,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9);
  });
}
function View_BookingRateCalulationComponent_8(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'inline-icon error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oops! Only numerical values and \'.\' are allowed.'])),
    (l()(),import1.ɵted((null as any),['!\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_BookingRateCalulationComponent_7(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'payroll-card__measure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll-card__measure-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Inter. rate WKN'])),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'input',[
      [
        'class',
        'payroll-card__measure-input'
      ]
      ,
      [
        'pattern',
        '\\$?(\\d+|\\d+(\\.)\\d+)'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,8)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,8).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,8)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,8)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.payrollInvoice.interpreting_weekend_rate = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(540672,(null as any),0,import2.PatternValidator,([] as any[]),{pattern: [
        0,
        'pattern'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.PatternValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
      import1.ɵdid(671744,[[
        'interRateWKN',
        4
      ]
    ],0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingRateCalulationComponent_8)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_10:any = '\\$?(\\d+|\\d+(\\.)\\d+)';
    ck(v,9,0,currVal_10);
    const currVal_11:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'interRateWKN_') + co.index),'');
    const currVal_12:any = ((co.payrollInvoice == null)? (null as any): co.payrollInvoice.interpreting_weekend_rate);
    ck(v,12,0,currVal_11,currVal_12);
    const currVal_13:any = (import1.ɵnov(v,12).touched && ((import1.ɵnov(v,12).errors == null)? (null as any): import1.ɵnov(v,12).errors.pattern));
    ck(v,17,0,currVal_13);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.isReadOnly;
    const currVal_1:any = co.totalPlaceholder;
    const currVal_2:any = (import1.ɵnov(v,9).pattern? import1.ɵnov(v,9).pattern: (null as any));
    const currVal_3:any = import1.ɵnov(v,14).ngClassUntouched;
    const currVal_4:any = import1.ɵnov(v,14).ngClassTouched;
    const currVal_5:any = import1.ɵnov(v,14).ngClassPristine;
    const currVal_6:any = import1.ɵnov(v,14).ngClassDirty;
    const currVal_7:any = import1.ɵnov(v,14).ngClassValid;
    const currVal_8:any = import1.ɵnov(v,14).ngClassInvalid;
    const currVal_9:any = import1.ɵnov(v,14).ngClassPending;
    ck(v,7,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9);
  });
}
export function View_BookingRateCalulationComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    import1.ɵqud(402653184,1,{form: 0}),
    (l()(),import1.ɵeld(0,(null as any),(null as any),101,'form',[
      [
        'ngForm',
        'calculationFields'
      ]
      ,
      [
        'novalidate',
        ''
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,3).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,3).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.ɵbf,([] as any[]),(null as any),(null as any)),
    import1.ɵdid(16384,[
      [
        1,
        4
      ]
      ,
      [
        'calculationFields',
        4
      ]

    ]
    ,0,import2.NgForm,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    import1.ɵprd(2048,(null as any),import2.ControlContainer,(null as any),[import2.NgForm]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatusGroup,[import2.ControlContainer],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),85,'footer',[[
        'class',
        'payroll-card__footer common-form'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'payroll-card__measure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll-card__measure-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Inter. rate *'])),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'input',[
      [
        'class',
        'payroll-card__measure-input'
      ]
      ,
      [
        'pattern',
        '\\$?(\\d+|\\d+(\\.)\\d+)'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import4.BookingRateCalulationComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,17)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,17).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,17)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,17)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.payrollInvoice.interpreting_rate = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(540672,(null as any),0,import2.PatternValidator,([] as any[]),{pattern: [
        0,
        'pattern'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.PatternValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
      import1.ɵdid(671744,[[
        'interpreterRateOrd',
        4
      ]
    ],0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingRateCalulationComponent_1)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'payroll-card__measure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll-card__measure-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Prep. rate *'])),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'input',[
      [
        'class',
        'payroll-card__measure-input'
      ]
      ,
      [
        'pattern',
        '\\$?(\\d+|\\d+(\\.|\\:)\\d+)'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import4.BookingRateCalulationComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,38)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,38).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,38)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,38)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.payrollInvoice.preparation_rate = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(540672,(null as any),0,import2.PatternValidator,([] as any[]),{pattern: [
        0,
        'pattern'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.PatternValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
      import1.ɵdid(671744,[[
        'prepRate',
        4
      ]
    ],0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingRateCalulationComponent_2)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'payroll-card__measure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll-card__measure-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Travel rate *'])),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'input',[
      [
        'class',
        'payroll-card__measure-input'
      ]
      ,
      [
        'pattern',
        '\\$?(\\d+|\\d+(\\.|\\:)\\d+)'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import4.BookingRateCalulationComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,59)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,59).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,59)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,59)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.payrollInvoice.travel_rate = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(540672,(null as any),0,import2.PatternValidator,([] as any[]),{pattern: [
        0,
        'pattern'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.PatternValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
      import1.ɵdid(671744,[[
        'travelRate',
        4
      ]
    ],0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingRateCalulationComponent_3)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'payroll-card__measure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll-card__measure-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Total'])),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'input',[
      [
        'class',
        'payroll-card__measure-input'
      ]
      ,
      [
        'pattern',
        '\\$?(\\d+|\\d+(\\.)\\d+)'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import4.BookingRateCalulationComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,80)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,80).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,80)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,80)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.payrollInvoice.total = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(540672,(null as any),0,import2.PatternValidator,([] as any[]),{pattern: [
        0,
        'pattern'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.PatternValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
      import1.ɵdid(671744,[[
        'total',
        4
      ]
    ],0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingRateCalulationComponent_4)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),7,'footer',[[
        'class',
        'payroll-card__footer common-form'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingRateCalulationComponent_5)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingRateCalulationComponent_7)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.BookingRateCalulationComponent = v.component;
    const currVal_17:any = '\\$?(\\d+|\\d+(\\.)\\d+)';
    ck(v,18,0,currVal_17);
    const currVal_18:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'interpreterRateOrd_') + co.index),'');
    const currVal_19:any = ((co.payrollInvoice == null)? (null as any): co.payrollInvoice.interpreting_rate);
    ck(v,21,0,currVal_18,currVal_19);
    const currVal_20:any = (import1.ɵnov(v,21).touched && ((import1.ɵnov(v,21).errors == null)? (null as any): import1.ɵnov(v,21).errors.pattern));
    ck(v,26,0,currVal_20);
    const currVal_31:any = '\\$?(\\d+|\\d+(\\.|\\:)\\d+)';
    ck(v,39,0,currVal_31);
    const currVal_32:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'prepRate_') + co.index),'');
    const currVal_33:any = ((co.payrollInvoice == null)? (null as any): co.payrollInvoice.preparation_rate);
    ck(v,42,0,currVal_32,currVal_33);
    const currVal_34:any = (import1.ɵnov(v,42).touched && ((import1.ɵnov(v,42).errors == null)? (null as any): import1.ɵnov(v,42).errors.pattern));
    ck(v,47,0,currVal_34);
    const currVal_45:any = '\\$?(\\d+|\\d+(\\.|\\:)\\d+)';
    ck(v,60,0,currVal_45);
    const currVal_46:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'travel_') + co.index),'');
    const currVal_47:any = ((co.payrollInvoice == null)? (null as any): co.payrollInvoice.travel_rate);
    ck(v,63,0,currVal_46,currVal_47);
    const currVal_48:any = (import1.ɵnov(v,63).touched && ((import1.ɵnov(v,63).errors == null)? (null as any): import1.ɵnov(v,63).errors.pattern));
    ck(v,68,0,currVal_48);
    const currVal_59:any = '\\$?(\\d+|\\d+(\\.)\\d+)';
    ck(v,81,0,currVal_59);
    const currVal_60:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'total_') + co.index),'');
    const currVal_61:any = ((co.payrollInvoice == null)? (null as any): co.payrollInvoice.total);
    ck(v,84,0,currVal_60,currVal_61);
    const currVal_62:any = (import1.ɵnov(v,84).touched && ((import1.ɵnov(v,84).errors == null)? (null as any): import1.ɵnov(v,84).errors.pattern));
    ck(v,89,0,currVal_62);
    const currVal_63:any = co.isNG;
    ck(v,97,0,currVal_63);
    const currVal_64:any = co.isWKN;
    ck(v,100,0,currVal_64);
  },(ck,v) => {
    var co:import4.BookingRateCalulationComponent = v.component;
    const currVal_0:any = import1.ɵnov(v,5).ngClassUntouched;
    const currVal_1:any = import1.ɵnov(v,5).ngClassTouched;
    const currVal_2:any = import1.ɵnov(v,5).ngClassPristine;
    const currVal_3:any = import1.ɵnov(v,5).ngClassDirty;
    const currVal_4:any = import1.ɵnov(v,5).ngClassValid;
    const currVal_5:any = import1.ɵnov(v,5).ngClassInvalid;
    const currVal_6:any = import1.ɵnov(v,5).ngClassPending;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_7:any = co.isReadOnly;
    const currVal_8:any = co.interpRateOrdPlaceholder;
    const currVal_9:any = (import1.ɵnov(v,18).pattern? import1.ɵnov(v,18).pattern: (null as any));
    const currVal_10:any = import1.ɵnov(v,23).ngClassUntouched;
    const currVal_11:any = import1.ɵnov(v,23).ngClassTouched;
    const currVal_12:any = import1.ɵnov(v,23).ngClassPristine;
    const currVal_13:any = import1.ɵnov(v,23).ngClassDirty;
    const currVal_14:any = import1.ɵnov(v,23).ngClassValid;
    const currVal_15:any = import1.ɵnov(v,23).ngClassInvalid;
    const currVal_16:any = import1.ɵnov(v,23).ngClassPending;
    ck(v,16,0,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16);
    const currVal_21:any = co.isReadOnly;
    const currVal_22:any = co.prepRatePlaceholder;
    const currVal_23:any = (import1.ɵnov(v,39).pattern? import1.ɵnov(v,39).pattern: (null as any));
    const currVal_24:any = import1.ɵnov(v,44).ngClassUntouched;
    const currVal_25:any = import1.ɵnov(v,44).ngClassTouched;
    const currVal_26:any = import1.ɵnov(v,44).ngClassPristine;
    const currVal_27:any = import1.ɵnov(v,44).ngClassDirty;
    const currVal_28:any = import1.ɵnov(v,44).ngClassValid;
    const currVal_29:any = import1.ɵnov(v,44).ngClassInvalid;
    const currVal_30:any = import1.ɵnov(v,44).ngClassPending;
    ck(v,37,0,currVal_21,currVal_22,currVal_23,currVal_24,currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,currVal_30);
    const currVal_35:any = co.isReadOnly;
    const currVal_36:any = co.travelRatePlaceholder;
    const currVal_37:any = (import1.ɵnov(v,60).pattern? import1.ɵnov(v,60).pattern: (null as any));
    const currVal_38:any = import1.ɵnov(v,65).ngClassUntouched;
    const currVal_39:any = import1.ɵnov(v,65).ngClassTouched;
    const currVal_40:any = import1.ɵnov(v,65).ngClassPristine;
    const currVal_41:any = import1.ɵnov(v,65).ngClassDirty;
    const currVal_42:any = import1.ɵnov(v,65).ngClassValid;
    const currVal_43:any = import1.ɵnov(v,65).ngClassInvalid;
    const currVal_44:any = import1.ɵnov(v,65).ngClassPending;
    ck(v,58,0,currVal_35,currVal_36,currVal_37,currVal_38,currVal_39,currVal_40,currVal_41,currVal_42,currVal_43,currVal_44);
    const currVal_49:any = true;
    const currVal_50:any = co.totalPlaceholder;
    const currVal_51:any = (import1.ɵnov(v,81).pattern? import1.ɵnov(v,81).pattern: (null as any));
    const currVal_52:any = import1.ɵnov(v,86).ngClassUntouched;
    const currVal_53:any = import1.ɵnov(v,86).ngClassTouched;
    const currVal_54:any = import1.ɵnov(v,86).ngClassPristine;
    const currVal_55:any = import1.ɵnov(v,86).ngClassDirty;
    const currVal_56:any = import1.ɵnov(v,86).ngClassValid;
    const currVal_57:any = import1.ɵnov(v,86).ngClassInvalid;
    const currVal_58:any = import1.ɵnov(v,86).ngClassPending;
    ck(v,79,0,currVal_49,currVal_50,currVal_51,currVal_52,currVal_53,currVal_54,currVal_55,currVal_56,currVal_57,currVal_58);
  });
}
function View_BookingRateCalulationComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-booking-rate-calulation',([] as any[]),(null as any),(null as any),(null as any),View_BookingRateCalulationComponent_0,RenderType_BookingRateCalulationComponent)),
    import1.ɵdid(114688,(null as any),0,import4.BookingRateCalulationComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const BookingRateCalulationComponentNgFactory:import1.ComponentFactory<import4.BookingRateCalulationComponent> = import1.ɵccf('app-booking-rate-calulation',import4.BookingRateCalulationComponent,View_BookingRateCalulationComponent_Host_0,{
  payrollInvoice: 'payrollInvoice',
  index: 'index',
  isClient: 'isClient',
  parentForm: 'parentForm',
  isReadOnly: 'isReadOnly'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvYm9va2luZy1yYXRlLWNhbGN1bGF0aW9uIC9ib29raW5nLXJhdGUtY2FsdWxhdGlvbi5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9zcmMvYXBwL2Jvb2tpbmctbWFuYWdlbWVudC9ib29raW5nLXJhdGUtY2FsY3VsYXRpb24gL2Jvb2tpbmctcmF0ZS1jYWx1bGF0aW9uLmNvbXBvbmVudC50cyIsIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvYm9va2luZy1yYXRlLWNhbGN1bGF0aW9uIC9ib29raW5nLXJhdGUtY2FsdWxhdGlvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvYm9va2luZy1yYXRlLWNhbGN1bGF0aW9uIC9ib29raW5nLXJhdGUtY2FsdWxhdGlvbi5jb21wb25lbnQudHMuQm9va2luZ1JhdGVDYWx1bGF0aW9uQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGZvcm0gbmdGb3JtPVwiY2FsY3VsYXRpb25GaWVsZHNcIiAjY2FsY3VsYXRpb25GaWVsZHM9XCJuZ0Zvcm1cIj5cbiAgPGZvb3RlciBjbGFzcz1cInBheXJvbGwtY2FyZF9fZm9vdGVyIGNvbW1vbi1mb3JtXCI+XG4gICAgPGRpdiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZVwiPlxuICAgICAgPHNwYW4gY2xhc3M9XCJwYXlyb2xsLWNhcmRfX21lYXN1cmUtbmFtZVwiPkludGVyLiByYXRlICo8L3NwYW4+XG4gICAgICA8ZGl2IGNsYXNzPVwiZm9ybS1maWVsZFwiPlxuICAgICAgICA8aW5wdXQgdHlwZT1cInRleHRcIlxuICAgICAgICAgICAgICAgbmFtZT1cInt7KGlzQ2xpZW50ID8gJ2NsaWVudF8nIDogJ2ludGVycHJldGVyXycpICsgJ2ludGVycHJldGVyUmF0ZU9yZF8nICsgaW5kZXh9fVwiXG4gICAgICAgICAgICAgICAjaW50ZXJwcmV0ZXJSYXRlT3JkPVwibmdNb2RlbFwiXG4gICAgICAgICAgICAgICBbcmVhZG9ubHldPVwiaXNSZWFkT25seVwiXG4gICAgICAgICAgICAgICBbcGxhY2Vob2xkZXJdPVwiaW50ZXJwUmF0ZU9yZFBsYWNlaG9sZGVyXCJcbiAgICAgICAgICAgICAgIGNsYXNzPVwicGF5cm9sbC1jYXJkX19tZWFzdXJlLWlucHV0XCJcbiAgICAgICAgICAgICAgIFtuZ01vZGVsXT1cInBheXJvbGxJbnZvaWNlPy5pbnRlcnByZXRpbmdfcmF0ZVwiXG4gICAgICAgICAgICAgICAobmdNb2RlbENoYW5nZSk9XCJwYXlyb2xsSW52b2ljZS5pbnRlcnByZXRpbmdfcmF0ZSA9ICRldmVudFwiXG4gICAgICAgICAgICAgICBwYXR0ZXJuPVwiXFwkPyhcXGQrfFxcZCsoXFwuKVxcZCspXCI+XG4gICAgICAgIDxzcGFuICpuZ0lmPVwiaW50ZXJwcmV0ZXJSYXRlT3JkLnRvdWNoZWQgJiYgKGludGVycHJldGVyUmF0ZU9yZC5lcnJvcnM/LnBhdHRlcm4pO1wiIGNsYXNzPVwiaW5saW5lLWljb24gZXJyb3JcIj5cbiAgICAgICAgICA8c3Bhbj5Pb3BzISBPbmx5IG51bWVyaWNhbCB2YWx1ZXMgYW5kIFwiLlwiIGFyZSBhbGxvd2VkLjwvc3Bhbj4hXG4gICAgICAgIDwvc3Bhbj5cbiAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuICAgIDxkaXYgY2xhc3M9XCJwYXlyb2xsLWNhcmRfX21lYXN1cmVcIj5cbiAgICAgIDxzcGFuIGNsYXNzPVwicGF5cm9sbC1jYXJkX19tZWFzdXJlLW5hbWVcIj5QcmVwLiByYXRlICo8L3NwYW4+XG4gICAgICA8ZGl2IGNsYXNzPVwiZm9ybS1maWVsZFwiPlxuICAgICAgICA8aW5wdXQgdHlwZT1cInRleHRcIlxuICAgICAgICAgICAgICAgbmFtZT1cInt7KGlzQ2xpZW50ID8gJ2NsaWVudF8nIDogJ2ludGVycHJldGVyXycpICsgJ3ByZXBSYXRlXycgKyBpbmRleH19XCJcbiAgICAgICAgICAgICAgICNwcmVwUmF0ZT1cIm5nTW9kZWxcIlxuICAgICAgICAgICAgICAgW3JlYWRvbmx5XT1cImlzUmVhZE9ubHlcIlxuICAgICAgICAgICAgICAgW3BsYWNlaG9sZGVyXT1cInByZXBSYXRlUGxhY2Vob2xkZXJcIlxuICAgICAgICAgICAgICAgY2xhc3M9XCJwYXlyb2xsLWNhcmRfX21lYXN1cmUtaW5wdXRcIlxuICAgICAgICAgICAgICAgW25nTW9kZWxdPVwicGF5cm9sbEludm9pY2U/LnByZXBhcmF0aW9uX3JhdGVcIlxuICAgICAgICAgICAgICAgKG5nTW9kZWxDaGFuZ2UpPVwicGF5cm9sbEludm9pY2UucHJlcGFyYXRpb25fcmF0ZSA9ICRldmVudFwiXG4gICAgICAgICAgICAgICBwYXR0ZXJuPVwiXFwkPyhcXGQrfFxcZCsoXFwufFxcOilcXGQrKVwiPlxuICAgICAgICA8c3BhbiAqbmdJZj1cInByZXBSYXRlLnRvdWNoZWQgJiYgKHByZXBSYXRlLmVycm9ycz8ucGF0dGVybik7XCIgY2xhc3M9XCJpbmxpbmUtaWNvbiBlcnJvclwiPlxuICAgICAgICAgIDxzcGFuPk9vcHMhIE9ubHkgbnVtZXJpY2FsIHZhbHVlcyBhbmQgJy4nIGFyZSBhbGxvd2VkLjwvc3Bhbj4hXG4gICAgICAgIDwvc3Bhbj5cbiAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuICAgIDxkaXYgY2xhc3M9XCJwYXlyb2xsLWNhcmRfX21lYXN1cmVcIj5cbiAgICAgIDxzcGFuIGNsYXNzPVwicGF5cm9sbC1jYXJkX19tZWFzdXJlLW5hbWVcIj5UcmF2ZWwgcmF0ZSAqPC9zcGFuPlxuICAgICAgPGRpdiBjbGFzcz1cImZvcm0tZmllbGRcIj5cbiAgICAgICAgPGlucHV0IHR5cGU9XCJ0ZXh0XCJcbiAgICAgICAgICAgICAgIG5hbWU9XCJ7eyhpc0NsaWVudCA/ICdjbGllbnRfJyA6ICdpbnRlcnByZXRlcl8nKSArICd0cmF2ZWxfJyArIGluZGV4fX1cIlxuICAgICAgICAgICAgICAgI3RyYXZlbFJhdGU9XCJuZ01vZGVsXCJcbiAgICAgICAgICAgICAgIFtyZWFkb25seV09XCJpc1JlYWRPbmx5XCJcbiAgICAgICAgICAgICAgIFtwbGFjZWhvbGRlcl09XCJ0cmF2ZWxSYXRlUGxhY2Vob2xkZXJcIlxuICAgICAgICAgICAgICAgY2xhc3M9XCJwYXlyb2xsLWNhcmRfX21lYXN1cmUtaW5wdXRcIlxuICAgICAgICAgICAgICAgW25nTW9kZWxdPVwicGF5cm9sbEludm9pY2U/LnRyYXZlbF9yYXRlXCJcbiAgICAgICAgICAgICAgIChuZ01vZGVsQ2hhbmdlKT1cInBheXJvbGxJbnZvaWNlLnRyYXZlbF9yYXRlID0gJGV2ZW50XCJcbiAgICAgICAgICAgICAgIHBhdHRlcm49XCJcXCQ/KFxcZCt8XFxkKyhcXC58XFw6KVxcZCspXCI+XG4gICAgICAgIDxzcGFuICpuZ0lmPVwidHJhdmVsUmF0ZS50b3VjaGVkICYmICh0cmF2ZWxSYXRlLmVycm9ycz8ucGF0dGVybik7XCIgY2xhc3M9XCJpbmxpbmUtaWNvbiBlcnJvclwiPlxuICAgICAgICAgIDxzcGFuPk9vcHMhIE9ubHkgbnVtZXJpY2FsIHZhbHVlcyBhbmQgXCIuXCIgYXJlIGFsbG93ZWQuPC9zcGFuPiFcbiAgICAgICAgPC9zcGFuPlxuICAgICAgPC9kaXY+XG4gICAgPC9kaXY+XG4gICAgPGRpdiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZVwiPlxuICAgICAgPHNwYW4gY2xhc3M9XCJwYXlyb2xsLWNhcmRfX21lYXN1cmUtbmFtZVwiPlRvdGFsPC9zcGFuPlxuICAgICAgPGRpdiBjbGFzcz1cImZvcm0tZmllbGRcIj5cbiAgICAgICAgPGlucHV0IHR5cGU9XCJ0ZXh0XCJcbiAgICAgICAgICAgICAgIG5hbWU9XCJ7eyhpc0NsaWVudCA/ICdjbGllbnRfJyA6ICdpbnRlcnByZXRlcl8nKSArICd0b3RhbF8nICsgaW5kZXh9fVwiXG4gICAgICAgICAgICAgICAjdG90YWw9XCJuZ01vZGVsXCJcbiAgICAgICAgICAgICAgIFtyZWFkb25seV09XCJ0cnVlXCJcbiAgICAgICAgICAgICAgIFtwbGFjZWhvbGRlcl09XCJ0b3RhbFBsYWNlaG9sZGVyXCJcbiAgICAgICAgICAgICAgIGNsYXNzPVwicGF5cm9sbC1jYXJkX19tZWFzdXJlLWlucHV0XCJcbiAgICAgICAgICAgICAgIFtuZ01vZGVsXT1cInBheXJvbGxJbnZvaWNlPy50b3RhbFwiXG4gICAgICAgICAgICAgICAobmdNb2RlbENoYW5nZSk9XCJwYXlyb2xsSW52b2ljZS50b3RhbCA9ICRldmVudFwiXG4gICAgICAgICAgICAgICBwYXR0ZXJuPVwiXFwkPyhcXGQrfFxcZCsoXFwuKVxcZCspXCI+XG4gICAgICAgIDxzcGFuICpuZ0lmPVwidG90YWwudG91Y2hlZCAmJiAodG90YWwuZXJyb3JzPy5wYXR0ZXJuKTtcIiBjbGFzcz1cImlubGluZS1pY29uIGVycm9yXCI+XG4gICAgICAgICAgPHNwYW4+T29wcyEgT25seSBudW1lcmljYWwgdmFsdWVzIGFuZCAnLicgYXJlIGFsbG93ZWQuPC9zcGFuPiFcbiAgICAgICAgPC9zcGFuPlxuICAgICAgPC9kaXY+XG4gICAgPC9kaXY+XG4gIDwvZm9vdGVyPlxuICA8Zm9vdGVyIGNsYXNzPVwicGF5cm9sbC1jYXJkX19mb290ZXIgY29tbW9uLWZvcm1cIj5cbiAgICA8ZGl2IGNsYXNzPVwicGF5cm9sbC1jYXJkX19tZWFzdXJlXCIgKm5nSWY9J2lzTkcnPlxuICAgICAgPHNwYW4gY2xhc3M9XCJwYXlyb2xsLWNhcmRfX21lYXN1cmUtbmFtZVwiPkludGVyLiByYXRlIE5HPC9zcGFuPlxuICAgICAgPGRpdiBjbGFzcz1cImZvcm0tZmllbGRcIj5cbiAgICAgICAgPGlucHV0IHR5cGU9XCJ0ZXh0XCJcbiAgICAgICAgICAgICAgIG5hbWU9XCJ7eyhpc0NsaWVudCA/ICdjbGllbnRfJyA6ICdpbnRlcnByZXRlcl8nKSArICdpbnRlclJhdGVOR18nICsgaW5kZXh9fVwiXG4gICAgICAgICAgICAgICAjaW50ZXJSYXRlTkc9XCJuZ01vZGVsXCJcbiAgICAgICAgICAgICAgIFtyZWFkb25seV09XCJpc1JlYWRPbmx5XCJcbiAgICAgICAgICAgICAgIFtwbGFjZWhvbGRlcl09XCJ0b3RhbFBsYWNlaG9sZGVyXCJcbiAgICAgICAgICAgICAgIGNsYXNzPVwicGF5cm9sbC1jYXJkX19tZWFzdXJlLWlucHV0XCJcbiAgICAgICAgICAgICAgIFtuZ01vZGVsXT1cInBheXJvbGxJbnZvaWNlPy5pbnRlcnByZXRpbmdfbmlnaHRfcmF0ZVwiXG4gICAgICAgICAgICAgICAobmdNb2RlbENoYW5nZSk9XCJwYXlyb2xsSW52b2ljZS5pbnRlcnByZXRpbmdfbmlnaHRfcmF0ZSA9ICRldmVudFwiXG4gICAgICAgICAgICAgICBwYXR0ZXJuPVwiXFwkPyhcXGQrfFxcZCsoXFwuKVxcZCspXCI+XG4gICAgICAgIDxzcGFuICpuZ0lmPVwiaW50ZXJSYXRlTkcudG91Y2hlZCAmJiAoaW50ZXJSYXRlTkcuZXJyb3JzPy5wYXR0ZXJuKTtcIiBjbGFzcz1cImlubGluZS1pY29uIGVycm9yXCI+XG4gICAgICAgICAgPHNwYW4+T29wcyEgT25seSBudW1lcmljYWwgdmFsdWVzIGFuZCAnLicgYXJlIGFsbG93ZWQuPC9zcGFuPiFcbiAgICAgICAgPC9zcGFuPlxuICAgICAgPC9kaXY+XG4gICAgPC9kaXY+XG4gICAgPGRpdiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZVwiICpuZ0lmPSdpc1dLTic+XG4gICAgICA8c3BhbiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZS1uYW1lXCI+SW50ZXIuIHJhdGUgV0tOPC9zcGFuPlxuICAgICAgPGRpdiBjbGFzcz1cImZvcm0tZmllbGRcIj5cbiAgICAgICAgPGlucHV0IHR5cGU9XCJ0ZXh0XCJcbiAgICAgICAgICAgICAgIG5hbWU9XCJ7eyhpc0NsaWVudCA/ICdjbGllbnRfJyA6ICdpbnRlcnByZXRlcl8nKSArICdpbnRlclJhdGVXS05fJyArIGluZGV4fX1cIlxuICAgICAgICAgICAgICAgI2ludGVyUmF0ZVdLTj1cIm5nTW9kZWxcIlxuICAgICAgICAgICAgICAgW3JlYWRvbmx5XT1cImlzUmVhZE9ubHlcIlxuICAgICAgICAgICAgICAgW3BsYWNlaG9sZGVyXT1cInRvdGFsUGxhY2Vob2xkZXJcIlxuICAgICAgICAgICAgICAgY2xhc3M9XCJwYXlyb2xsLWNhcmRfX21lYXN1cmUtaW5wdXRcIlxuICAgICAgICAgICAgICAgW25nTW9kZWxdPVwicGF5cm9sbEludm9pY2U/LmludGVycHJldGluZ193ZWVrZW5kX3JhdGVcIlxuICAgICAgICAgICAgICAgKG5nTW9kZWxDaGFuZ2UpPVwicGF5cm9sbEludm9pY2UuaW50ZXJwcmV0aW5nX3dlZWtlbmRfcmF0ZSA9ICRldmVudFwiXG4gICAgICAgICAgICAgICBwYXR0ZXJuPVwiXFwkPyhcXGQrfFxcZCsoXFwuKVxcZCspXCI+XG4gICAgICAgIDxzcGFuICpuZ0lmPVwiaW50ZXJSYXRlV0tOLnRvdWNoZWQgJiYgKGludGVyUmF0ZVdLTi5lcnJvcnM/LnBhdHRlcm4pO1wiIGNsYXNzPVwiaW5saW5lLWljb24gZXJyb3JcIj5cbiAgICAgICAgICA8c3Bhbj5Pb3BzISBPbmx5IG51bWVyaWNhbCB2YWx1ZXMgYW5kICcuJyBhcmUgYWxsb3dlZC48L3NwYW4+IVxuICAgICAgICA8L3NwYW4+XG4gICAgICA8L2Rpdj5cbiAgICA8L2Rpdj5cbiAgPC9mb290ZXI+XG48L2Zvcm0+XG4iLCI8YXBwLWJvb2tpbmctcmF0ZS1jYWx1bGF0aW9uPjwvYXBwLWJvb2tpbmctcmF0ZS1jYWx1bGF0aW9uPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7TUNjUTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTRHO0lBQzFHO0lBQU07SUFBdUQ7Ozs7OztNQWdCL0Q7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF3RjtJQUN0RjtJQUFNO0lBQXVEOzs7Ozs7TUFnQi9EO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBNEY7SUFDMUY7SUFBTTtJQUF1RDs7Ozs7O01BZ0IvRDtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQWtGO0lBQ2hGO0lBQU07SUFBdUQ7Ozs7OztNQWtCL0Q7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUE4RjtJQUM1RjtJQUFNO0lBQXVEOzs7Ozs7TUFibkU7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFnRDtNQUM5QztRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXlDO0lBQXFCO01BQzlEO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBd0I7SUFDdEI7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQU9PO1FBQUE7UUFBQTtNQUFBO01BUFA7SUFBQTtnQkFBQTs7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtLQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTs7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7O01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Z0JBQUE7SUFRcUM7SUFDckM7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUVPO0lBQ0g7Ozs7SUFKRztJQVJQLFNBUU8sVUFSUDtJQUNPO0lBS0E7SUFOUCxVQUNPLFdBS0EsVUFOUDtJQVNNO0lBQU4sVUFBTSxVQUFOOzs7SUFOTztJQUNBO0lBSlA7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFNBR08sVUFDQSxVQUpQLFVBQUEscUVBQUE7Ozs7O01BMEJBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBZ0c7SUFDOUY7SUFBTTtJQUF1RDs7Ozs7O01BYm5FO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBaUQ7TUFDL0M7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF5QztJQUFzQjtNQUMvRDtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXdCO0lBQ3RCO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFPTztRQUFBO1FBQUE7TUFBQTtNQVBQO0lBQUE7Z0JBQUE7OztNQUFBO1FBQUE7O01BQUE7O0lBQUE7S0FBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO1FBQUE7O01BQUE7O01BQUE7UUFBQTs7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBO2dCQUFBO0lBUXFDO0lBQ3JDO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFFTztJQUNIOzs7O0lBSkc7SUFSUCxTQVFPLFVBUlA7SUFDTztJQUtBO0lBTlAsVUFDTyxXQUtBLFVBTlA7SUFTTTtJQUFOLFVBQU0sVUFBTjs7O0lBTk87SUFDQTtJQUpQO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxTQUdPLFVBQ0EsVUFKUCxVQUFBLHFFQUFBOzs7Ozs7SUE1RlI7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO0lBQUE7Z0JBQUE7Z0JBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBQTtnQkFBQTtJQUE2RDtNQUMzRDtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQWlEO01BQy9DO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBbUM7TUFDakM7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF5QztJQUFvQjtNQUM3RDtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXdCO0lBQ3RCO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFPTztRQUFBO1FBQUE7TUFBQTtNQVBQO0lBQUE7Z0JBQUE7OztNQUFBO1FBQUE7O01BQUE7O0lBQUE7S0FBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO1FBQUE7O01BQUE7O01BQUE7UUFBQTs7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBO2dCQUFBO0lBUXFDO0lBQ3JDO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFFTztJQUNIO0lBQ0Y7TUFDTjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQW1DO01BQ2pDO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBeUM7SUFBbUI7TUFDNUQ7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF3QjtJQUN0QjtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BT087UUFBQTtRQUFBO01BQUE7TUFQUDtJQUFBO2dCQUFBOzs7TUFBQTtRQUFBOztNQUFBOztJQUFBO0tBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtRQUFBOztNQUFBOztNQUFBO1FBQUE7O01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBQTtnQkFBQTtJQVF3QztJQUN4QztnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBRU87SUFDSDtJQUNGO01BQ047UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFtQztNQUNqQztRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXlDO0lBQW9CO01BQzdEO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBd0I7SUFDdEI7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQU9PO1FBQUE7UUFBQTtNQUFBO01BUFA7SUFBQTtnQkFBQTs7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtLQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTs7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7O01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Z0JBQUE7SUFRd0M7SUFDeEM7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUVPO0lBQ0g7SUFDRjtNQUNOO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBbUM7TUFDakM7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF5QztJQUFZO01BQ3JEO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBd0I7SUFDdEI7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQU9PO1FBQUE7UUFBQTtNQUFBO01BUFA7SUFBQTtnQkFBQTs7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtLQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTs7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7O01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Z0JBQUE7SUFRcUM7SUFDckM7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUVPO0lBQ0g7SUFDRjtJQUNDO01BQ1Q7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFpRDtJQUMvQztnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBZ0JNO0lBQ047Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQWdCTTtJQUNDO0lBQ0o7Ozs7SUE5RlE7SUFSUCxVQVFPLFVBUlA7SUFDTztJQUtBO0lBTlAsVUFDTyxXQUtBLFVBTlA7SUFTTTtJQUFOLFVBQU0sVUFBTjtJQWdCTztJQVJQLFVBUU8sVUFSUDtJQUNPO0lBS0E7SUFOUCxVQUNPLFdBS0EsVUFOUDtJQVNNO0lBQU4sVUFBTSxVQUFOO0lBZ0JPO0lBUlAsVUFRTyxVQVJQO0lBQ087SUFLQTtJQU5QLFVBQ08sV0FLQSxVQU5QO0lBU007SUFBTixVQUFNLFVBQU47SUFnQk87SUFSUCxVQVFPLFVBUlA7SUFDTztJQUtBO0lBTlAsVUFDTyxXQUtBLFVBTlA7SUFTTTtJQUFOLFVBQU0sVUFBTjtJQU8rQjtJQUFuQyxVQUFtQyxVQUFuQztJQWlCbUM7SUFBbkMsV0FBbUMsVUFBbkM7OztJQXpGSjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFNBQUEscUVBQUE7SUFRZTtJQUNBO0lBSlA7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFVBR08sVUFDQSxVQUpQLFVBQUEsNEVBQUE7SUFvQk87SUFDQTtJQUpQO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxVQUdPLFdBQ0EsV0FKUCxXQUFBLDRFQUFBO0lBb0JPO0lBQ0E7SUFKUDtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsVUFHTyxXQUNBLFdBSlAsV0FBQSw0RUFBQTtJQW9CTztJQUNBO0lBSlA7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFVBR08sV0FDQSxXQUpQLFdBQUEsNEVBQUE7Ozs7O0lDeERSO2dCQUFBOzs7SUFBQTs7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/booking-management/booking-rate-calculation /booking-rate-calulation.component.ngfactory.ts